module.exports = __webpack_public_path__ + "img/mail.ad78f14b.webp";